import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import AlertsViewModel from "../viewModels/alertsViewModel";

const AlertsView: ViewComponent<AlertsViewModel> = observer(({ vm }) => (
  <div className="sticky-alerts">
    {vm.children.map((child, index) => (
      <Observer key={index}>{() => <View vm={child} key={index} />}</Observer>
    ))}
  </div>
));

registerView(AlertsView, AlertsViewModel);
